<template>
  <div :style="[customCss]">
    <img
      class="w-full h-full object-cover"
      :src="themeSettings.configuration_options.background_image"
    />
    <div class="w-full h-full absolute left-0 top-0 body-overlay-color"></div>
  </div>
</template>
<script>
export default {
  name: 'JustImage',
  props: {
    getThemeSettings: {},
  },
  components: {},
  computed: {
    customCss() {
      return {
        '--template-overlay-color':
          this.themeSettings.body_section.overlay_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss">
@import '../../../../assets/css/campton_font.css';

.full-tile-hover {
  .tile-wrapper {
    position: relative;
    .relative {
      position: static;
    }
  }
}

.body-overlay-color {
  background: var(--template-overlay-color);
}
</style>